import { CheckboxProps } from './types';

import * as S from './styles';

const Checkbox: React.FC<CheckboxProps> = ({ error, ...props }) => (
  <S.StyledCheckbox hasError={!!error} {...props} />
);

export default Checkbox;
